import { makeStyles } from '@material-ui/core/styles';
import { EX4883 } from 'config/flags';

const useStyles = makeStyles((theme) => ({
    root: {
        flex: 1,
        padding: '24px 48px',
        //display: 'flex',
        flexDirection: 'column',
        //overflow: "scroll",
        overflowX: 'hidden',
        overflowY: 'auto',
        height: EX4883 ? 'calc(100vh - 120px)' : 'calc(94vh - 55px)',
        position: 'relative',
        backgroundColor: EX4883 ? '#F5F6FA' : '#fff',
    },
    rootDrugManuf: {
        flex: 1,
        padding: '24px 48px',
        display: 'flex',
        flexDirection: 'column',
        //overflow: "scroll",
        overflowX: 'hidden',
        overflowY: 'auto',
        height: EX4883 ? 'calc(100vh - 120px)' : 'calc(94vh - 55px)',
        position: 'relative',
        backgroundColor: '#F0F5FF',
    },
    rootV2: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        //overflow: "scroll",
        overflowX: 'hidden',
        overflowY: 'auto',
        height: 'calc(100vh - 120px)',
        position: 'relative',
        backgroundColor: '#F0F5FF',
        padding: '24px 48px 80px 48px',
    },
    container: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        height: 'calc(100vh)',

        position: 'relative',
    },
    wrapper: {
        flex: 1,
        padding: '24px',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'scroll',
        overflowX: 'hidden',
        height: 'calc(100vh - 220px)',
        position: 'relative',
    },
}));

export default useStyles;
